var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from 'react';
import { Card, Grid, Typography } from '@material-ui/core';
import { EmailSignUpForm } from './EmailSignUpForm';
import { EmbeddedSignUpCardStyles, EmbeddedSignUpCardStylesIsLoggedOutHomeRedesign, EmbeddedSignUpStyles, EmbeddedSignUpStylesIsLoggedOutHomeRedesign, } from './EmbeddedSignUpTypes';
import { SocialSignUpForm } from './SocialSignUpForm';
var EmbeddedSignUpHeader = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, _b = _a.excludeTitle, excludeTitle = _b === void 0 ? false : _b, _c = _a.isReferral, isReferral = _c === void 0 ? false : _c, _d = _a.isLoggedOutHomeRedesign, isLoggedOutHomeRedesign = _d === void 0 ? false : _d;
    var classes = isLoggedOutHomeRedesign ? EmbeddedSignUpStylesIsLoggedOutHomeRedesign() : EmbeddedSignUpStyles();
    var signupTitle = title || 'Explore your creativity';
    var signupSubtitle = subtitle || 'Get started for free';
    var getHeader = function () {
        if (excludeTitle) {
            return (React.createElement(Typography, { component: "h3", variant: "h3", className: classes.subTitle }, signupSubtitle));
        }
        else if (isReferral) {
            return (React.createElement(React.Fragment, null,
                React.createElement(Typography, { component: "h2", variant: "h1", className: classes.marketingAlt }, signupTitle),
                React.createElement(Typography, { component: "h3", variant: "body2", className: classes.subTitleAlt }, signupSubtitle)));
        }
        else if (isLoggedOutHomeRedesign) {
            return (React.createElement(React.Fragment, null,
                React.createElement(Typography, { component: "h2", variant: "h1", className: classes.marketing },
                    "Explore your creativity with thousands of online classes",
                    React.createElement("span", { style: { color: '#00FF84' } }, ".")),
                React.createElement(Typography, { component: "h3", variant: "h2", className: classes.subTitle }, "Start learning for free")));
        }
        else {
            return (React.createElement(React.Fragment, null,
                React.createElement(Typography, { component: "h2", variant: "h1", className: classes.marketing }, signupTitle),
                React.createElement(Typography, { component: "h3", variant: "body2", className: classes.subTitle }, signupSubtitle)));
        }
    };
    return getHeader();
};
export function EmbeddedSignUp(props) {
    var redirectTo = props.redirectTo, _a = props.onlyEmail, onlyEmail = _a === void 0 ? false : _a, header = props.header, _b = props.config, config = _b === void 0 ? {} : _b, _c = props.signUpCta, signUpCta = _c === void 0 ? 'Sign Up' : _c, _d = props.excludeTitle, excludeTitle = _d === void 0 ? false : _d, _e = props.hideFirstLastName, hideFirstLastName = _e === void 0 ? false : _e, _f = props.isLoggedOutHomeRedesign, isLoggedOutHomeRedesign = _f === void 0 ? false : _f, _g = props.isReferral, isReferral = _g === void 0 ? false : _g, title = props.title, subtitle = props.subtitle;
    var _h = __read(useState(onlyEmail), 2), isEmailFormOpen = _h[0], setIsEmailFormOpen = _h[1];
    var cardClasses = isLoggedOutHomeRedesign
        ? EmbeddedSignUpCardStylesIsLoggedOutHomeRedesign(props)
        : EmbeddedSignUpCardStyles(props);
    var classes = isLoggedOutHomeRedesign ? EmbeddedSignUpStylesIsLoggedOutHomeRedesign() : EmbeddedSignUpStyles();
    var cardClass = cardClasses.root + " " + (config.isMUIResponsive ? cardClasses.cardMui : '');
    var formClass = classes.form + " " + (config.isMUIResponsive ? classes.formMui : '');
    return (React.createElement(Grid, { container: true, className: classes.container },
        React.createElement(Card, { className: cardClass },
            React.createElement(Grid, { className: formClass },
                header ? (React.createElement(React.Fragment, null,
                    " ",
                    header,
                    " ")) : (React.createElement(EmbeddedSignUpHeader, { title: title, subtitle: subtitle, excludeTitle: excludeTitle, isReferral: isReferral, isLoggedOutHomeRedesign: isLoggedOutHomeRedesign })),
                React.createElement("div", { className: classes.formContainer }, isEmailFormOpen ? (React.createElement(EmailSignUpForm, { redirectTo: redirectTo, isModal: false, signUpCta: signUpCta, hideLogin: true, hideFirstLastName: hideFirstLastName, isLoggedOutHomeRedesign: isLoggedOutHomeRedesign })) : (React.createElement(SocialSignUpForm, { redirectTo: redirectTo, switchToEmailSignUp: setIsEmailFormOpen, excludeTitle: excludeTitle, hideLogin: true, isLoggedOutHomeRedesign: isLoggedOutHomeRedesign }))),
                config.bottomMobileIcon && React.createElement("div", { className: classes.iconContainer }, config.bottomMobileIcon)))));
}
//# sourceMappingURL=EmbeddedSignUp.js.map